export default "__VITE_ASSET__BuCmakhU__"